import { render, staticRenderFns } from "./elementEvents.vue?vue&type=template&id=15860603"
import script from "./elementEvents.vue?vue&type=script&lang=js"
export * from "./elementEvents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports